























































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import VueQrcode from 'vue-qrcode';

import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import MarketingCenterMockup from '@/components/molecules/MarketingCenter/Mockup/Mockup.vue';
import eventBus from '@/utils/eventBus';
import { copyToClipboard } from '@/utils';
import { IMarketingCenterTemplate } from '@/models/marketingCenter/template';
import apiService from '@/api';
import { getAssetsURL } from '@/models/marketingCenter/post';
import MarketingCenterService from '@/api/MarketingCenterService';

@Component({
  components: {
    VueQrcode,
    Surface,
    Typography,
    Picture,
    FilledButton,
    MarketingCenterMockup
  }
})
export default class MarketingCenterDownloadModal extends Vue {
  @Prop() readonly template?: IMarketingCenterTemplate;
  @Prop() readonly postId?: string;
  @Prop(String) readonly gaContextPage!: string;
  selections: string[] = [];
  copied: boolean = false;
  api = new apiService();
  marketingCenterService = new MarketingCenterService();
  link: string = '';
  loading: boolean = false;
  stillLoading: boolean = false;
  timeout?: ReturnType<typeof setTimeout>;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  @Watch('copied')
  timeoutCopied() {
    setTimeout(() => {
      this.copied = false;
    }, 3000);
  }

  async download() {
    this.$analytics({
      eventCategory: `${this.gaContextPage} | Download Post`,
      eventAction: 'click',
      eventLabel: 'Click on the "Download" button'
    });

    if (!this.selections.length) return;

    this.loading = true;

    this.timeout = setTimeout(() => {
      this.stillLoading = true;
    }, 3000);

    const query = this.selections.reduce(
      (acc, selection) => `${acc}&template=${selection}`,
      ''
    );

    const response = await this.marketingCenterService.downloadAssets(
      this.id,
      query.length ? query.replace('&', '?') : ''
    );

    const blob = new Blob([response.data], {
      type: 'application/zip'
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = 'assets.zip';
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    clearTimeout(this.timeout);
    this.stillLoading = false;
    this.loading = false;
  }

  changeSelection(format: string) {
    if (this.selections.includes(format)) {
      this.selections = this.selections.filter(
        (selection: string) => selection !== format
      );
      return;
    }

    this.selections = [...this.selections, format];
  }

  mounted() {
    if (this.template) {
      this.selections = this.template.formats.map((format: any) => format.key);
    }

    this.link = getAssetsURL(this.id);
  }

  onCopy() {
    if (!this.copied) {
      this.$analytics({
        eventCategory: `${this.gaContextPage} | Download Modal | Copy Link`,
        eventAction: 'click',
        eventLabel: 'Copied link'
      });

      copyToClipboard(this.link);
      this.copied = true;
    }
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  get id() {
    return this.postId || this.$route.params.post;
  }
}
